import React from 'react';
import { ActivationCard } from './ActivationCard';

interface ErrorScreenProps {
  errorMessage: string | null;
  onStartOver: () => void;
  title?: string;
}

export const ErrorScreen: React.FC<ErrorScreenProps> = ({
  errorMessage,
  onStartOver,
  title = 'Activation Error',
}) => (
  <ActivationCard>
    <div className="text-center">
      <div className="mb-4">
        <i className="fas fa-exclamation-triangle text-danger" style={{ fontSize: '4rem' }}></i>
      </div>
      <h1 className="h3 mb-3 fw-bold">{title}</h1>
      <div className="alert alert-danger" role="alert">
        <i className="fas fa-exclamation-circle me-2"></i>
        {errorMessage || 'An unexpected error occurred.'}
      </div>
      <button onClick={onStartOver} className="btn btn-primary w-100">
        <i className="fas fa-redo me-2"></i>
        Start Over
      </button>
    </div>
  </ActivationCard>
);
